"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bacon, Dispatcher;

Bacon = require('baconjs');

Dispatcher = function () {
  function Dispatcher() {
    var storeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "BUS";

    _classCallCheck(this, Dispatcher);

    this.storeName = storeName;
    this._busCache = {};
  }

  _createClass(Dispatcher, [{
    key: "bus",
    value: function bus(name) {
      if (!this._busCache[name]) {
        this._busCache[name] = new Bacon.Bus();
        if (__DEV__) {
          this._busCache[name].log("[" + this.storeName + "::" + name + "]: ");
        }
      }
      return this._busCache[name];
    }
  }, {
    key: "stream",
    value: function stream(name) {
      return this.bus(name);
    }
  }, {
    key: "push",
    value: function push(name, value) {
      return this.bus(name).push(value);
    }
  }, {
    key: "plug",
    value: function plug(name, value) {
      return this.bus(name).plug(value);
    }
  }]);

  return Dispatcher;
}();

module.exports = Dispatcher;